import React from "react";

import { css } from "@emotion/css";
import { CellContext } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

import { FontSizes } from "@/assets/fonts.ts";
import { Icons } from "@/assets/icons.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import type { LibreViewClinicPatient } from "@/models/LibreViewModel.ts";
import { Queries } from "@/queries/Queries.ts";
import { Button } from "@/uiKit/atoms/Button.tsx";
import { TextToast } from "@/uiKit/atoms/Toast.tsx";
import { ColumnHeader } from "@/uiKit/organisms/PatientSync/columnHeader.tsx";

export const IgnoreCell: React.FC<CellContext<LibreViewClinicPatient, unknown>> = ({ row }) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();
  const ignore = Queries.patientSync.useIgnoreLibreViewPatient();

  return (
    <Button
      variant="text"
      data-action="sync.grouped-inclusion.ignore"
      startIcon={<Icons.exit className={styles.icon} />}
      onClick={() =>
        ignore.mutate(
          {
            email: row.original.email,
            ignoreType: "refused_during_pre_inclusion",
          },
          {
            onSuccess: () => {
              TextToast.success(t("patientSync.libreviewTable.patientIgnored"));
            },
          },
        )
      }
    />
  );
};

export const IgnoreHeader: React.FC = () => <ColumnHeader translationKey="patientSync.libreviewTable.ignore" />;

const makeStyles = () => ({
  icon: css({
    width: FontSizes.body,
    height: FontSizes.body,
  }),
});
